import { render, staticRenderFns } from "./SupEdit.vue?vue&type=template&id=78b59ec8&scoped=true"
import script from "./SupEdit.vue?vue&type=script&lang=js"
export * from "./SupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b59ec8",
  null
  
)

export default component.exports